import { request } from "../../utils/config"
import { loginVariables, login_login } from "./types/login"
import { registerVariables, register } from "./types/register"

type Login = (data: loginVariables) => Promise<login_login | null>
type Register = (data: registerVariables) => Promise<register>

export const LOGIN: Login = async (data) => {
  // Parol URL query-stringda emas, body orqali yuboriladi (loglar/tarixga tushmasligi uchun)
  const response = await request({
    url: `AccountAPI/Login`,
    method: "POST",
    data: { email: data.email, password: data.password },
  })
  return response.data
}

// 2FA: Telegram'ga yuborilgan kodni tekshirish. Muvaffaqiyatda javob shakli
// Login bilan bir xil ({result:{accessToken,...}}) — SIGN_IN o'sha oqimda ketadi.
export const VERIFY_2FA = async (data: { email: string; code: string }) => {
  const response = await request({
    url: `AccountAPI/VerifyTwoFactor`,
    method: "POST",
    data: { email: data.email, code: data.code },
  })
  return response.data
}

export const REGISTER: Register = async (data) => {
  const response = await request({
    url: "AccountAPI/Register",
    method: "POST",
    data: data,
  })
  return response.data
}

export const LOGOUT = async () => {
  try {
    const response = await request({
      url: "AccountAPI/Logout",
      method: "POST",
    })
    return response.data
  } catch (e) {
    console.error("Logout API error:", e)
  }
}
